<!-- =========================================================================================
    File Name: DeviceStatus.vue
    Description: Изменение статуса устройств
========================================================================================== -->


<template>
    <vs-prompt
        title="Изменение статуса устройств"
        accept-text= "Сохранить"
        cancel-text = "Закрыть"
        button-cancel = "border"
        @accept="submitAction"
        :is-valid="validateForm"
        :active.sync="activePrompt">
        <div>
            <form>

                <div class="vx-row">
                    <div class="vx-col w-full">
                        <vs-select v-model="stateLocal" label="Новый статус для устройств" class="w-50">
                            <vs-select-item :key="item.value" :value="item.value" :text="item.label" v-for="item in partnerDeviceStateList" />
                        </vs-select>
                    </div>
                </div>

            </form>
        </div>
    </vs-prompt>
</template>

<script>
import modulePartner          from '@/store/partner/modulePartner.js'

export default {
    props: {
        displayPrompt: {
            type: Boolean,
            required: true,
        },
        devices: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            partnerDeviceStateList: modulePartner.partnerDeviceStateList,
            stateLocal: this.devices[0].state,
        }
    },
    computed: {
        activePrompt: {
            get() {
                return this.displayPrompt
            },
            set(value) {
                this.$emit('hidePromptStatus', value)
            }
        },
        validateForm() {
            return !this.errors.any()
        }
    },
    methods: {
        submitAction() {
            this.$store.dispatch("partner/updateDevicesState", {devices: this.devices, state: this.stateLocal})
        }

    },
}
</script>

<style lang="scss">

    .con-select {
        width: 350px;
    }

</style>